import { take } from 'rxjs';
import { assign } from "lodash";
import { ChangeDetectionStrategy, Component, ContentChild, ElementRef, Input, TemplateRef, type AfterViewInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import * as FlatModels from '@medsurf/flat-models';
import * as FlatFacades from '@medsurf/flat-facades';
import { MediaControlService } from '@medsurf/flat-services';

@Component({
    selector: 'medsurf-design-content-template-node-tree',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './template-node-tree.content.design.html',
    styleUrls: ['./template-node-tree.content.design.scss'],
    standalone: false
})
export class TemplateNodeTreeContentDesign implements AfterViewInit{
  @Input() name?: string;
  @Input() inputClass?: string;
  
  @ContentChild('override_menu_template') override_menu_template?: TemplateRef<ElementRef>;
  @ContentChild('override_node_template') override_node_template?: TemplateRef<ElementRef>;
  
  handled = false;
  localTypedNodeExpanded: { [id: string]: boolean } = {};
  readonly FlatModels = FlatModels;

  constructor(public alertControlFacade: FlatFacades.AlertControlFacade,
              public navigationControlFacade: FlatFacades.NavigationControlFacade,
              public nodeSharedFacade: FlatFacades.NodeSharedFacade,
              public slideAuthorFacade: FlatFacades.SlideAuthorFacade,
              public mediaControlService: MediaControlService) {
    // Typed Node Expanded
    this.slideAuthorFacade.typedNodeExpanded$.pipe(takeUntilDestroyed()).subscribe((typedNodeExpanded) => {
      this.localTypedNodeExpanded = typedNodeExpanded;
    });
  }
  
  ngAfterViewInit(): void {
    setTimeout(() => {
      // Get Current Typed Expanded
      this.slideAuthorFacade.typedNodeExpanded$.pipe(take(1)).subscribe((typedNodeExpanded) => {
        this.localTypedNodeExpanded = assign(structuredClone(this.localTypedNodeExpanded), typedNodeExpanded);
        this.slideAuthorFacade.requestSetTypedNodeExpanded(this.localTypedNodeExpanded);
      });
      this.nodeSharedFacade.currentTypedExpanded$.pipe(take(1)).subscribe((typedNodeExpanded) => {
        this.localTypedNodeExpanded = assign(structuredClone(this.localTypedNodeExpanded), typedNodeExpanded);
        this.slideAuthorFacade.requestSetTypedNodeExpanded(this.localTypedNodeExpanded);
      });
    });
  }
  
  handleEvent() {
    this.handled = true;
  }

  //<editor-fold desc="Node">

  trackByNode(index: number,
              item: FlatModels.NodeEntityModels.NodeEntityType) {
    return item.id + item.position || index;
  }

  onNodeExpand(node: FlatModels.NodeEntityModels.NodeEntityType,
               override?: boolean) {
    this.handleEvent();
    this.localTypedNodeExpanded[node.id] = override ? override : !this.localTypedNodeExpanded[node.id];
    this.slideAuthorFacade.requestSetTypedNodeExpanded(this.localTypedNodeExpanded).subscribe({
      error: (result) => this.alertControlFacade.requestAddError(result)
    });
    this.nodeSharedFacade.requestNodesByParentId(node.id).subscribe({
      error: (result) => this.alertControlFacade.requestAddError(result)
    });
  }

  onNodeSelect(routeElement: FlatModels.NodeEntityModels.RouteElement) {
    if (this.handled) {
      this.handled = false;
      return;
    }
    this.navigationControlFacade.requestNavigate([routeElement.path]);
  }

  //</editor-fold>
  
  getColor(themeColor: string) {
    return themeColor && FlatModels.ColorConfigModels.themeColorList.find(tcl => tcl.value === themeColor)?.hexValue || themeColor;
  }
  
  getSolid(themeColor: string) {
    return themeColor && themeColor.length > 0 ? FlatModels.ButtonDesignModels.ButtonSolidStyle : '';
  }
}
